import React, { Component } from 'react';

import Button from 'components/Button';
import Header from 'components/Header';
import cross from './img/cross.svg';

import './styles.css';

class PairUnavailable extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="pair-unavailable">
        <Header light />

        <div className="info">
          <div className="status">
            <img className="status__img" src={cross} width="28" height="28" alt="Failed" />
          </div>

          <h1 className="info__title">Pair unavailable</h1>
          <p className="info__paragraph">Go back and try another pair or come back later.</p>
          <div className="info__button">
            <Button
              color="blue"
              size="medium"
              text="Go back"
              href="/"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PairUnavailable;



// WEBPACK FOOTER //
// ./src/scenes/PairUnavailable/index.jsx